import { createBrowserRouter } from 'react-router-dom';
import MainLayout from '../layouts/main-layout.tsx';
import routes from '~/modules/storefront/router/routes.ts';
import { ComponentType } from 'react';
import LoadingElement from '../../@shared/components/LoadingElement/LoadingElement.tsx';
import { RouterFallbackElement } from '~/modules/@shared/components/ErrorBoundary/components/RouterFallbackElement';
import { LoginLayout } from '~/modules/storefront/layouts/login-layout.tsx';

const router = createBrowserRouter([
  {
    Component: MainLayout as unknown as ComponentType<{}>,
    HydrateFallback: LoadingElement as unknown as ComponentType<{}>,
    errorElement: <RouterFallbackElement />,
    path: '/',
    children: [
      {
        path: routes.profile,
        lazy: () => import('../pages/profile'),
      },
    ],
  },
  {
    Component: LoginLayout as unknown as ComponentType<{}>,
    HydrateFallback: LoadingElement as unknown as ComponentType<{}>,
    errorElement: <RouterFallbackElement />,
    path: '/',
    children: [
      {
        path: routes.auth.login,
        lazy: () => import('../pages/auth/login'),
      },
      {
        path: routes.auth.create_password,
        lazy: () => import('../pages/auth/create-password'),
      },
      {
        path: routes.auth.forgot_password,
        lazy: () => import('../pages/auth/forgot-password'),
      },
      {
        path: routes.auth.forgot_password_reset,
        lazy: () => import('../pages/auth/forgot-password-reset'),
      },
      {
        path: routes.auth.forgot_password_submission,
        lazy: () => import('../pages/auth/forgot-password-submission'),
      },
    ],
  },
]);

export default router;
